import userPlansService from '@/services/user-plans'
import nodesService from '@/services/nodes'

export const fetchUserPlans = context =>
  userPlansService
    .getAll()
    .then(userPlans => context.commit('userPlansUpdated', userPlans))

export const fetchNodes = context =>
  nodesService.getAll().then(nodes => context.commit('nodesUpdated', nodes))

export const fetchClusters = context =>
  nodesService
    .getAllClusters()
    .then(clusters => context.commit('clustersUpdated', clusters))
